import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from './AppShell';
import './ContactUs.css';

const ContactUs: React.FC = () => {
  const navigate = useNavigate();

  const header = (
    <div className="contact-us-header app-shell-header-content">
      <button
        onClick={() => navigate('/profile/settings')}
        className="back-button"
        title="返回设置"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h1>联系我们</h1>
    </div>
  );

  return (
    <AppShell header={header} footer={null}>
      <div className="contact-us-container">
        <div className="contact-content">
          <div className="contact-form">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div className="contact-item-content">
                  <div className="contact-item-label">微信</div>
                  <div className="contact-item-value">Szadati</div>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div className="contact-item-content">
                  <div className="contact-item-label">邮箱</div>
                  <div className="contact-item-value">minamiplus6@outlook.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
};

export default ContactUs;

